var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNetworth(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 30,
    viewBox: "0 0 31 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 30,
    height: 30,
    rx: 10,
    fill: "#F3F1FE"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1690_7131)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.1665 17.6666C18.1665 16.93 16.0772 16.3333 13.4998 16.3333M18.1665 17.6666C18.1665 18.4033 16.0772 19 13.4998 19C10.9225 19 8.83317 18.4033 8.83317 17.6666M18.1665 17.6666V20.958C18.1665 21.7173 16.0772 22.3333 13.4998 22.3333C10.9225 22.3333 8.83317 21.718 8.83317 20.958V17.6666M18.1665 17.6666C20.7158 17.6666 22.8332 17.0086 22.8332 16.3333V9.66665M13.4998 16.3333C10.9225 16.3333 8.83317 16.93 8.83317 17.6666M13.4998 16.3333C10.5545 16.3333 8.1665 15.6753 8.1665 15V11.6666M13.4998 10.3333C10.5545 10.3333 8.1665 10.93 8.1665 11.6666M8.1665 11.6666C8.1665 12.4033 10.5545 13 13.4998 13C13.4998 13.6753 15.6685 14.3333 18.2178 14.3333C20.7665 14.3333 22.8332 13.6753 22.8332 13M22.8332 9.66665C22.8332 8.92998 20.7665 8.33331 18.2178 8.33331C15.6685 8.33331 13.6025 8.92998 13.6025 9.66665M22.8332 9.66665C22.8332 10.4033 20.7665 11 18.2178 11C15.6692 11 13.6025 10.4033 13.6025 9.66665M13.6025 9.66665V16.444",
    stroke: "#C6C0FA"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1690_7131"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(7.5 7)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNetworth);
export default __webpack_public_path__ + "static/media/networth.47e9ff19886e16d97e5740545d42c196.svg";
export { ForwardRef as ReactComponent };